import React from 'react';

const dogCEODescription = () => {

    return (
        <div style={{ paddingBottom: '100px' }}>
            <div className='ui grid'>
                <div className="centered row">
                    <div className="sixteen wide column centered">
                        <h1 className="ui header">Dog CEO Challenge</h1>
                    </div>
                </div>
                <div className='row'>
                    <div className="sixteen wide column">
                        <h2 className="ui header">Description</h2>
                    </div>
                </div>
                <div className='row'>
                    <div className="sixteen wide column">
                        <p>
                            The challenge consisted of building a web application, using React, 
                            that allows for the search and filtering of images associated with different dog breeds and sub-breeds. 
                            A public API called Dog API was used. The application is available at https://dog-ceo-challenge.netlify.app/.
                        </p>
                    </div>
                </div>
                <div className='spaced row'>
                    <div className="sixteen wide column center aligned">
                        <a href="https://dog-ceo-challenge.netlify.app/">
                            <div className='ui small button'>
                                <i className='external alternate icon'></i> Check it out
                            </div>
                        </a>
                        <a href="https://github.com/jomavera/dogceochallenge">
                            <div className='ui small button'>
                                <i className='github icon'></i> Repo
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default dogCEODescription;